import type { Dispatch } from 'redux';
import { connect } from '@atlassian/jira-react-redux';
import { VIEW_SETTINGS_PANEL } from '../../../../model/panels/constants';
import { NO_SWIMLANE } from '../../../../model/swimlane/swimlane-modes';
import { setShowUnscheduledColumn } from '../../../../state/actions/board/menu';
import { closeInsightsPanel, togglePanel } from '../../../../state/actions/panels';
import { swimlanesCollapse, swimlanesExpand } from '../../../../state/actions/swimlane';
import { getViewSettingsPanel } from '../../../../state/selectors/panels';
import {
	getHierarchyNomenclature,
	getIsCMPBoard,
	rapidViewIdSelector,
} from '../../../../state/selectors/software/software-selectors';
import { getSwimlaneMode } from '../../../../state/selectors/swimlane/swimlane-mode-selectors';
import { platformSwimlaneIdsSelector } from '../../../../state/selectors/work/work-selectors';
import type { State } from '../../../../state/types';
import { type DispatchProps, type StateProps, ViewSettings } from './view';

export const mapStateToProps = (state: State): StateProps => {
	const hasSwimlanes = getSwimlaneMode(state) !== NO_SWIMLANE.id;
	const isCMPBoard = getIsCMPBoard(state);
	const isViewSettingPanelOpen = getViewSettingsPanel(state);

	return {
		rapidViewId: Number(rapidViewIdSelector(state)),
		swimlaneIds: platformSwimlaneIdsSelector(state),
		isClassic: isCMPBoard,
		hasSwimlanes,
		epicCustomName: getHierarchyNomenclature(state)?.firstLevelName,
		isViewSettingPanelOpen,
	};
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
	onSwimlaneExpandAll: () => {
		dispatch(swimlanesExpand());
	},
	onSwimlaneCollapseAll: (swimlaneIds) => {
		dispatch(swimlanesCollapse(swimlaneIds));
	},
	onSetShowUnscheduledColumn: (isVisible: boolean) => {
		dispatch(setShowUnscheduledColumn(isVisible));
	},
	onTogglePanel: () => {
		dispatch(togglePanel(VIEW_SETTINGS_PANEL));
		dispatch(closeInsightsPanel());
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewSettings);
